import React, { useCallback, useEffect, useRef, useState } from "react";
import FeedTop from "../components/Feed/Main/FeedTop";
import DashboardHeader from "../components/Other/DashboardHeader";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart as empty,
  faBookmark,
} from "@fortawesome/free-regular-svg-icons";
import { faComment as empty2 } from "@fortawesome/free-regular-svg-icons";
import {
  faArrowUpFromBracket,
  faHeart,
  faTrash,
  faEllipsisH,
  faBookmark as saved,
  faBan,
  faRepeat,
  faFlag,
  faEllipsisV,
  faPlay,
  faPause,
  faMagnifyingGlass,
  faEdit,
} from "@fortawesome/free-solid-svg-icons";
import {
  getAllPost,
  deleteComment,
  repostPost,
  addComment,
  likeDislike,
  getComment,
  deletePost,
  savePost,
  getMyPost,
  reportPostApi,
  blockUnblockUserApi,
  undoRepostPost,
} from "../api/user";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import PageContainer from "../components/pages/PageContainer";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoader from "../components/smallLoader";
import GreenTick from "../images/green-tick.png";
import BlockReportModal from "../components/Modals/blockandreport";
import UndoRepostModal from "../components/Modals/repostModal";
import { PreviewVideo } from "./previewVideo";
// import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";
// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import GameSideBar from "../components/Games/GameSideBar";
import { BASE_URL } from "../config/api";
import Default from "./Default.svg";
import {
  IconExit,
  CommentIcon,
  HeartFilledIcon,
  HeartIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon,
  TheDotsIcon,
  SaveIconFill
} from "../icons/icons";

import FeedCard from "../components/FeedCard/FeedCard";

const debounce = (func, delay) => {
  let debounceTimer;
  return function (...args) {
    const context = this;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
};

let hasScrolled = false;

const FeedPage = (props) => {
  const isMobileView = document.body.clientWidth <= 768;
  const [sidebarToggle] = useOutletContext();
  const { postId } = useParams();
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const game_id = props.gameId ?? null;
  const [pausedVideoId, setPausedVideoId] = useState(null);
  const slug = props.slug ?? null;
  const game = props.game ?? null;
  const [page, setPage] = useState(2);
  const [hasMore, setHasMore] = useState(true);
  const [commentOpenStates, setCommentOpenStates] = useState({});
  const [newComment, setNewComment] = useState("");
  const [postComments, setPostComments] = useState({});
  const [loading, setLoading] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loginUserId, setLoginUserId] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newid, setNewId] = useState("");
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [showFullRepostDescription, setShowFullRepostDescription] = useState(
    []
  );
  const [apiCall1, setApiCall1] = useState(false);
  const [dropdownStates, setDropdownStates] = useState([]);
  const [isBlockOpen, setIsBlockOpen] = useState(false);
  const [postType, setPostType] = useState("");
  const [blockReportIDs, setBlockReportIDs] = useState("");
  const [reportComment, setReportComment] = useState("");
  const [videoPlaying, setVideoPlaying] = useState([]);
  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;
  const [postUndo, setPostUndo] = useState(false);
  const [postUndoId, setPostUndoID] = useState("");
  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [apiCall, setApiCall] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  const [search, setSearch] = useState("");
  const [showVideos, setShowVideos] = useState(
    new Array(posts?.length).fill(false)
  );
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"];
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "flv", "mkv", "webm"];
  const videoRefs = useRef([]);

  //For Video

  const videosRef = useRef({});
  const [playing, setPlaying] = useState({});
  const [isMuted, setIsMuted] = useState(true); // Global mute state
   const [playingVideoId, setPlayingVideoId] = useState(null);
   const [isLoading, setIsLoading] = useState(true); // Track loading state
   const location = useLocation();
  const hasScrolledRef = useRef(false);

useEffect(() => {
  hasScrolledRef.current = false; // ✅ Reset when FeedPage mounts
}, [location.pathname]); // Runs only when the component mounts

const loadedVideosRef = useRef(new Set()); // Track which videos are loaded

const handleVideoCanPlay = (id) => {
  const video = videosRef.current[id];
  if (video) {
    video.pause(); // Pause by default
    setPlaying((prev) => ({ ...prev, [id]: false }));
    setIsLoading((prev) => ({ ...prev, [id]: false }));

    // Track loaded video
    loadedVideosRef.current.add(id);

    // After all videos loaded, check visibility
    checkAndPlayFirstVisibleVideo();
  }
};

const checkAndPlayFirstVisibleVideo = () => {
  let firstVisibleVideoId = null;

  Object.entries(videosRef.current).forEach(([id, video]) => {
    if (!video) return;
    const rect = video.getBoundingClientRect();

    // Check if at least 75% is visible
    const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
    const visibleRatio = visibleHeight / rect.height;

    if (visibleRatio >= 0.75 && !firstVisibleVideoId) {
      firstVisibleVideoId = id;
    }
  });

  // Play only the first visible video
  if (firstVisibleVideoId) {
    const video = videosRef.current[firstVisibleVideoId];
    if (video) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [firstVisibleVideoId]: true }));
    }
  }
};




  // useEffect(() => {
  //   const video = videosRef.current[posts.id];
  //   if (video) {
  //     video.load(); // ✅ Force browser to load video immediately
  //   }
  // }, []);

const handleVisibility = (id, isVisible) => {
  const video = videosRef.current[id];
  if (video) {
    if (isVisible) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlaying((prev) => ({ ...prev, [id]: false }));
    }
  }
};


useEffect(() => {
  if (document.body.clientWidth <= 768) return;

  let currentlyPlayingId = null;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const id = entry.target.getAttribute("data-id");
        const video = videosRef.current[id];
        if (!video) return;

        if (entry.isIntersecting) {
          if (currentlyPlayingId && currentlyPlayingId !== id) {
            const prevVideo = videosRef.current[currentlyPlayingId];
            if (prevVideo) {
              prevVideo.pause();
              setPlaying((prev) => ({ ...prev, [currentlyPlayingId]: false }));
            }
          }

          video.play().catch((e) => console.warn("Autoplay blocked:", e));
          setPlaying((prev) => ({ ...prev, [id]: true }));
          currentlyPlayingId = id;
        } else {
          video.pause();
          setPlaying((prev) => ({ ...prev, [id]: false }));
        }
      });
    },
    { threshold: 0.75 }
  );

  Object.values(videosRef.current).forEach((video) => {
    if (video) observer.observe(video);
  });

  return () => {
    Object.values(videosRef.current).forEach((video) => {
      if (video) observer.unobserve(video);
    });
    observer.disconnect();
  };
}, [posts]);


  console.log("videosRef.current", videosRef.current);
const checkVideosInView = () => {
  let newPlayingVideoId = playingVideoId; // Keep track of the current playing video
console.log("videosRef.current12", videosRef.current);
  Object.entries(videosRef.current).forEach(([id, video]) => {
    if (video) {
      const rect = video.getBoundingClientRect();
      const videoHeight = rect.bottom - rect.top;
      const videoVisibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

      // Check if at least 10% of the video is visible in the viewport
      const isAtLeast10PercentVisible = videoVisibleHeight / videoHeight >= 0.1;
      const completelyOutOfView = rect.bottom <= 0 || rect.top >= window.innerHeight;

      if (isAtLeast10PercentVisible) {
        newPlayingVideoId = id;
      }

      if (completelyOutOfView && playingVideoId === id) {
        video.pause();
        setPausedVideoId(null);
        newPlayingVideoId = null;
      }
    }
  });

  // If a new video should be played, play it and update state
  if (newPlayingVideoId !== playingVideoId) {
    Object.values(videosRef.current).forEach((v) => v?.pause());
    if (newPlayingVideoId) {
      // alert('dg');
      videosRef.current[newPlayingVideoId]?.play().catch(() => console.warn("Autoplay blocked"));
      //setPausedVideoId(null);
    }
    setPlayingVideoId(newPlayingVideoId);


        // 🧠 Clear the play icon if it's no longer on the currently playing video

      if (pausedVideoId && pausedVideoId !== playingVideoId) {
        setPausedVideoId(null);
      }


  }
};

// Attach scroll event listener
useEffect(() => {
  checkVideosInView(); // Check on mount
  window.addEventListener("scroll", checkVideosInView);

  return () => {
    window.removeEventListener("scroll", checkVideosInView);
  };
}, [playingVideoId]);


const togglePlay = (id) => {
  const video = videosRef.current[id];
  if (video) {
    const isPlaying = playing[id] ?? false; // default to false
    if (isPlaying) {
    //  alert('in if');
      video.pause();
      setPausedVideoId(id); // show overlay
    } else {
    //  alert('in else');
      video.play();
      setPausedVideoId(null); // hide overlay
    }

    setPlaying((prev) => ({ ...prev, [id]: !isPlaying }));
  }
};


  const toggleMute = () => {
    setIsMuted((prevMuted) => {
      const newMuteState = !prevMuted;
      Object.values(videosRef.current).forEach((video) => {
        if (video) video.muted = newMuteState;
      });
      return newMuteState;
    });
  };



//

  let fullImageUrl = null;
  let extension = null;

  //Use Effect
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
      zoom: false
    });
    lightbox.init();

    return () => {
      localStorage.setItem("toggle", "false");
      lightbox.destroy();
      lightbox = null;
    };
  }, [posts]);

  useEffect(() => {
    localStorage.removeItem("game_type");
    localStorage.removeItem("isAuthenticated");
    if (!isDataFeteched) fetchPost();
  }, [isDataFeteched]);

  useEffect(() => {
    const handleCustomProfileEvent = async (event) => {
      if (event?.detail?.posts) {
        setPosts(event?.detail?.posts);
      }
    };

    window.addEventListener("feedDataEvent", handleCustomProfileEvent);
    return () => {
      window.removeEventListener("feedDataEvent", handleCustomProfileEvent);
    };
  }, [window.addEventListener]);

  useEffect(() => {
    let user_id = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {};
    if (user_id && user_id?.id) {
      setLoginUserId(user_id?.id);
    }
  }, []);

  useEffect(() => {
  const video = document.querySelector("video"); // Select the video element

  if (video) {
    video.muted = true; // Ensure it's muted
    video.play().catch((err) => console.warn("Autoplay blocked:", err));
  }
}, []);



  useEffect(() => {
    const postIdToScroll = postId;
    if (postIdToScroll) {
      setCommentOpenStates((prevStates) => ({
        ...prevStates,
        [postIdToScroll]: true,
      }));
      fetchPostNotification(postIdToScroll);
    }
  }, [posts]);

  if (game) {
    const imagePath =
      game.game_image && game.game_image.length > 0
        ? game.game_image[0].image
        : null;

    const filename = imagePath ? imagePath.split("/").pop() : null;

    fullImageUrl = filename
      ? `${BASE_URL}/storage/upload/game/image/${filename}`
      : Default;

    extension = fullImageUrl.split(".").pop().toLowerCase();
  }

  const navigateToUserProfile = (event, userId) => {
    event.preventDefault();
    if (game_id) {
      navigate(`/${slug}/profile/${userId}`, {
        state: { game_id: game_id, slug: slug },
      });
    } else {
      navigate(`/profile/${userId}`, {
        state: { game_id: game_id, slug: slug },
      });
    }
  };

  const debouncedFetchOptions = useCallback(
    debounce((searchTerm) => {
      handleChange(searchTerm);
    }, 500),
    []
  );

  const handleChange = async (searchData) => {
    fetchPost(searchData, 1);
  };

  const handleInputChange = (e) => {
    setSearch(e.target.value);
    debouncedFetchOptions(e.target.value);
  };

  const fetchPost = async (searchData) => {
    try {
      if (!postId) {
        // if (!apiCall1) {
        let params = { page: 1 };

        // Check if game_id is available and add it to the params
        if (game_id) {
          params.game_id = game_id;
        }
        const response = await getAllPost(searchData ? searchData : "", params);
        if (response?.data?.status === 200) {
          const myCustomEvent = new CustomEvent("feedDataEvent", {
            detail: {
              posts: response?.data?.data?.data,
            },
          });
          window.dispatchEvent(myCustomEvent);
          setPosts(response?.data?.data?.data);
          setApiCall1(true);
          setTimeout(() => {
            setApiCall1(true);
          }, 3000);
          setisDataFeteched(true);
          setLoader(false);

          if (response?.data?.data?.game_notification > 0) {
            localStorage.setItem(
              "notificationCount",
              response?.data?.data?.game_notification
            );
          }
        } else {
          setApiCall1(false);
          setLoader(false);
        }
        // }
      }
    } catch (error) {
      setApiCall1(false);
      setLoader(false);
    }
  };

  const fetchPostNotification = async (id) => {
    try {
      if (id) {
        setLoader(true);
        const response = await getMyPost({ post_id: id });
        if (response?.data?.data?.data.length > 0) {
          setisDataFeteched(true);
          setPosts(response.data.data.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const handleImageLoaded = (event, imageIndex) => {
    const image = event.target;
    const linkElement = image.closest("a");
    linkElement.setAttribute("data-pswp-width", image.naturalWidth);
    linkElement.setAttribute("data-pswp-height", image.naturalHeight);
  };
  const galleryStyles = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gridGap: "20px",
  };

  const imageStyles = {
    width: "auto",
    height: "auto",
    objectFit: "cover",
    // border: "1px solid #ccc",
  };

  const linkStyles = {
    // background: "#f0f0f0",
    // padding: "1px",
    margin: "10px",
  };
  const handleBlockUserCancel = () => {
    setIsBlockOpen(false);
    setPostType("");
    setBlockReportIDs("");
  };

  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

useEffect(() => {
  setIsLoading((prevLoadingState) => {
    const newLoadingState = { ...prevLoadingState }; // Preserve previous state
    posts.forEach((post) => {
      if (!(post.id in newLoadingState)) {
        newLoadingState[post.id] = true; // Set only for new posts
      }
    });
    return newLoadingState;
  });
}, [posts]);


  const handleBlockUser = async () => {
    const res = await blockUnblockUserApi({ user_id: blockReportIDs });
    // console.log(res, "res-block");
    if (res?.data?.status === 200) {
      setIsBlockOpen(false);
      setPostType("");
      fetchPost();
      toast.success(res?.data?.message);
      setBlockReportIDs("");
    } else {
      toast.success(res?.data?.message);
    }
  };

  const handleReportPost = async () => {
    const obj = {
      post_id: blockReportIDs,
      comment: reportComment,
    };
    const res = await reportPostApi(obj);
    if (res?.data?.status === 200) {
      setIsBlockOpen(false);
      setPostType("");
      toast.success(res?.data?.message);
      setBlockReportIDs("");
      fetchPost();
      setReportComment("");
    } else {
      toast.success(res?.data?.message);
    }
  };

  const handleBlock = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };
  const handleReport = (id, type) => {
    setBlockReportIDs(id);
    setIsBlockOpen(true);
    setPostType(type);
  };

  const fetchMorePost = async () => {
    try {
      setLoader(true);
      let params = { page: page };

      // Check if game_id is available and add it to the params
      if (game_id) {
        params.game_id = game_id;
      }
      const response = await getAllPost("", params);
      if (response?.data?.status === 200) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
        setPage((pagePre) => pagePre + 1);
        setApiCall(true);
        setLoader(false);

        if (response?.data?.game_notification > 0) {
          localStorage.setItem(
            "notificationCount",
            response?.data?.game_notification
          );
        }
      } else {
        setApiCall(false);
        setHasMore(false);
        setLoader(false);
      }
    } catch (error) {
      setApiCall(false);
      setLoader(false);
    } finally {
      setApiCall(false);
      setLoader(false);
    }
  };

  const toggleDropdown = (index) => {
    // Copy the current states
    const newDropdownStates = [...dropdownStates];
    // If the index is out of bounds (e.g., first render), initialize it as false
    if (newDropdownStates.length <= index) {
      newDropdownStates[index] = false; // Initialize as closed
    }
    // Toggle the state
    newDropdownStates[index] = !newDropdownStates[index];
    // Update the state with the new array
    setDropdownStates(newDropdownStates);
  };

  const handleCommentToggle = async (index, id, isOpen) => {
    setLoadingComment(true);
    try {
      isOpen = isOpen !== undefined ? isOpen : !commentOpenStates[index];

      if (!isOpen) {
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: false,
        }));
        return;
      }
      const response = await getComment(id);
      if (response?.status === 200) {
        setTimeout(() => {
          setLoadingComment(false);
        }, 1000);
        setCommentOpenStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });

        const sortedChats = response?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setPostComments((prevComments) => ({
          ...prevComments,
          [id]: sortedChats,
        }));

        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: isOpen,
        }));
      }
    } catch (error) {
      setTimeout(() => {
        setLoadingComment(false);
      }, 1000);
    }
  };

  const handleAddComment = async (postId, index) => {
    if (newComment.length <= 255) {
      setIsDisabled(true);

      const body = {
        post_id: postId,
        comment: newComment,
      };
      try {
        const response = await addComment(body);
        if (response.status === 200) {
          await getComment(postId);
          handleCommentToggle(index, postId, true);
          setIsDisabled(false);
          setCommentOpenStates((prevStates) => ({
            ...prevStates,
            [postId]: false,
          }));
          setNewComment("");
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to add a comment");
        }
      } catch (error) {
        setIsDisabled(false);
      }
    } else {
      toast.error("Comment should be less that or equal to 255 characters.");
    }
  };

  function calculateTimeAgo(created_at) {
    const currentDate = new Date();
    const createdAtDate = new Date(created_at);
    const timeDifference = Math.max(
      0,
      currentDate.getTime() - createdAtDate.getTime()
    );

    const secondsInMs = 1000;
    const minutesInMs = secondsInMs * 60;
    const hoursInMs = minutesInMs * 60;
    const daysInMs = hoursInMs * 24;
    const monthsInMs = daysInMs * 30;
    const yearsInMs = daysInMs * 365;

    if (timeDifference < secondsInMs) {
      return "just now";
    } else if (timeDifference < minutesInMs) {
      return Math.round(timeDifference / secondsInMs) + "s ago";
    } else if (timeDifference < hoursInMs) {
      return Math.round(timeDifference / minutesInMs) + "m ago";
    } else if (timeDifference < daysInMs) {
      return Math.round(timeDifference / hoursInMs) + "h ago";
    } else if (timeDifference < monthsInMs) {
      return Math.round(timeDifference / daysInMs) + "d ago";
    } else if (timeDifference < yearsInMs) {
      return Math.round(timeDifference / monthsInMs) + "mo ago";
    } else {
      return Math.round(timeDifference / yearsInMs) + "y ago";
    }
  }

  const handleLikeDislike = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id === postId) {
        val.is_like_by_me = !val.is_like_by_me;
        val.total_likes =
          val.is_like_by_me === true
            ? val.total_likes + 1
            : val.total_likes - 1;
      } else if (val?.repost?.id === postId) {
        val.repost.is_like_by_me = !val.repost.is_like_by_me;
        val.repost.total_likes =
          val.repost.is_like_by_me === true
            ? val.repost.total_likes + 1
            : val.repost.total_likes - 1;
      }
      return val;
    });
    setPosts(postssss);

    setIsDisabled(true);
    try {
      const response = await likeDislike(postId);
      if (response.status === 200) {
        setLoading(false);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id === postId) {
            val.is_like_by_me = false;
            val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
          } else if (val?.repost?.id === postId) {
            val.repost.is_like_by_me = false;
            val.repost.total_likes =
              val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to update like/dislike status");
      }
    } catch (error) {
      const postssss = posts.map((val) => {
        if (val?.id === postId) {
          val.is_like_by_me = false;
          val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
        } else if (val?.repost?.id === postId) {
          val.repost.is_like_by_me = false;
          val.repost.total_likes =
            val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
        }
        return val;
      });
      setPosts(postssss);
      setIsDisabled(false);
    }
  };

  // const handleOpenModal = () => {
  //   setIsModalOpen(true);
  // };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDelete = async () => {
    try {
      const response = await deletePost(newid);
      if (response.status === 200) {
        setPosts((prevPosts) => prevPosts.filter((post) => post.id !== newid));
        // toast.success("Post deleted successfully");
        fetchPost();
        handleCloseModal();
      } else {
        throw new Error("Failed to delete the post");
      }
    } catch (error) {}
  };

  const handleDeleteComment = async (id) => {
    setIsDisabled(true);
    try {
      // const isConfirmed = window.confirm("Are you sure you want to delete this post?");
      // if (isConfirmed) {
      // Make API call to delete the post
      const response = await deleteComment(id); // You need to implement this function

      if (response.status === 200) {
        // Remove the deleted post from the state

        // toast.success("Comment deleted successfully");
        fetchPost();
        handleCommentToggle(true);
        setLoading(false);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        toast.error("Failed to delete the post");
        throw new Error("Failed to delete the post");
      }
      // }
    } catch (error) {
      setIsDisabled(false);
      // Handle error
    }
  };

  const handleUndoRepost = async () => {
    try {
      const res = await undoRepostPost(postUndoId);
      if (res.status === 200) {
        fetchPost();
        setPostUndo(false);
        setIsDisabled(false);
      }
      if (!res.ok) {
        setIsDisabled(false);
      }
    } catch (error) {
      setIsDisabled(false);
    }
  };

  const handleUndoCancel = () => {
    setPostUndo(false);
  };

  const handleRepost = async (postId, userId, id) => {
    if (userId == loginUserId) {
      setPostUndo(true);
      setPostUndoID(id);
    } else {
      setIsDisabled(true);
      try {
        const response = await repostPost(postId);
        if (response.status === 200) {
          fetchPost();
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to update like/dislike status");
        }
      } catch (error) {
        setIsDisabled(false);
      }
    }
  };
  const handleSavePost = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id === postId) {
        val.is_saved = !val.is_saved;
      } else if (val?.repost?.id === postId) {
        val.repost.is_saved = !val.repost.is_saved;
      }
      return val;
    });
    setPosts(postssss);
    setIsDisabled(true);
    try {
      const response = await savePost(postId);
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost();
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id === postId) {
            val.is_saved = false;
          } else if (val?.repost?.id === postId) {
            val.repost.is_saved = false;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to save post");
      }
    } catch (error) {
      setIsDisabled(false);
    }
  };

  const renderDescriptionDynamicLineBreaks = (description) => {
    const regex = /(\n+)/g;
    const parts = description && description.split(regex);

    if (!description || description == null) {
      return null;
    }
    return parts.map((part, index) => {
      if (part.match(regex)) {
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // const handleCloseModal = () => {
  //     setIsModalOpen(false);
  // };

  const handleDeletePost = async (postId) => {
    // alert(postId);
    // console.log(postId);
    handleOpenModal();
    setNewId(postId);
  };

  const handleEditClick = (postId) => {
    navigate(`/${slug}/edit-feed/${postId}`);
  };

  const handleShare = async (id) => {
    const urlToShare = `https://app.qushi.io/feed/${id}`;

    const shareData = {
      title: "QUSHI",
      text: "Check out this!",
      url: urlToShare,
    };
    try {
      if (navigator.share) {
        await navigator.clipboard.writeText(urlToShare);
        await navigator.share(shareData);
      } else {
        const el = document.createElement("textarea");
        el.value = urlToShare;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        const shareLinkPrompt = `Link copied\nShare this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const handleVideoClick_BKP = (index) => {
    const updatedShowVideos = [...showVideos];
    updatedShowVideos[index] = true;
    setShowVideos(updatedShowVideos);
    const videoRef = videoRefs.current[index];
    if (videoRef) {
      videoRef.play();
    }
  };

  const handleVideoClick = (postIndex, imageIndex) => {
    const key = `${postIndex}-${imageIndex}`;
    const videoRef = videoRefs.current[key];

    if (videoRef) {
      if (videoPlaying[key]) {
        videoRef.pause();
        setVideoPlaying((prev) => ({ ...prev, [key]: false }));
      } else {
        Object.keys(videoRefs.current).forEach((otherKey) => {
          if (otherKey !== key && videoRefs.current[otherKey]) {
            videoRefs.current[otherKey].pause();
            setVideoPlaying((prev) => ({ ...prev, [otherKey]: false }));
          }
        });
        videoRef
          .play()
          .then(() => {
            setVideoPlaying((prev) => ({ ...prev, [key]: true }));
          })
          .catch((error) => {
            console.error("Error playing video:", error);
          });
      }
    } else {
      setVideoPlaying((prev) => ({ ...prev, [key]: true }));
      const updatedShowVideos = [...showVideos];
      updatedShowVideos[postIndex] = true;
      if (videoRef) {
        videoRef.play();
      }
      setShowVideos(updatedShowVideos);
      console.warn(`No videoRef found for key: ${key}`);
    }
  };

  const handleVideoClick1 = (index) => {
    const updatedShowVideos = [...showVideos];
    updatedShowVideos[index] = true;

    setShowVideos(updatedShowVideos);

    const updatedVideoPlaying = [...videoPlaying];
    const videoRef = videoRefs.current[index];

    if (videoRef) {
      if (videoRef.paused) {
        videoRef.play();
        updatedVideoPlaying[index] = true;
      } else {
        videoRef.pause();
        updatedVideoPlaying[index] = false;
      }
      setVideoPlaying(updatedVideoPlaying);
    }
  };

  const getVideoThumbnail = (videoUrl) => {
    const video1 = videoUrl + ".jpg";
    return video1;
  };
  document.addEventListener("DOMContentLoaded", function () {
    function updateImageStyles() {
      const images = document.querySelectorAll(".pswp__img");
      images.forEach((img) => {});
    }

    document.addEventListener("pswp:afterInit", function (e) {
      updateImageStyles();
    });

    document.addEventListener("pswp:change", function (e) {
      updateImageStyles();
    });
  });
  const navigate = useNavigate();

  console.log(posts, "posts");

  const handleExitGame = () => {
    localStorage.removeItem("game_type");
    localStorage.removeItem("isAuthenticated");
    navigate("/contest/my-games", { state: { viewMode: "member" } });
  };

  const gameLeaderboard = () => {
    navigate(`/${slug}/leaderboard`);
  };

  // For Mobile
  const [commentBox, setCommentBox] = useState(false);
  const { post_image, total_likes, updated_at, description } = posts;
  const user = { name: posts?.user?.user_name, avatar: posts?.user?.image };
  const media = {
    type: post_image?.length && post_image[0].is_video ? "video" : "image",
    url: post_image?.length && post_image[0].image,
  };
  console.log(posts, " post description is");
  const caption = description;
  const initialComments = [
    { user: "Jane", text: "Wow! Looks amazing!", replies: [] },
    { user: "Alex", text: "I wish I was there!", replies: [] },
  ];
  const [liked, setLiked] = useState(false);
  const [commentText, setCommentText] = useState("");
  const [postComments1, setPostComments1] = useState(initialComments);
  const [replyText, setReplyText] = useState("");
  const [replyIndex, setReplyIndex] = useState(null);

  return (
    <>
      <DashboardHeader
        toggle={sidebarToggle}
        avatar={profile?.image}
        user={{ name: profile?.full_name }}
        setStocksData={setPosts}
        setLoader={setLoader}
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>Yay! You have seen it all</b>
          </p>
        }
        {...(game && { game })}
      />

      <PageContainer gamePage={game_id && true}>
        {game_id && <GameSideBar activeMenu="feeds" slug={slug} />}
        <div>
          {game_id && !isMobileView && (
            <button
              className="float-right px-3 h-[40px] rounded-[5px] py-1 mx-2 text-sm border-none cursor-pointer bg-primaryColor text-white"
              onClick={() => navigate(`/${slug}/create-feed`)}
            >
              Add Post
            </button>
          )}
          {game_id && isMobileView && (
            <div className="grid grid-cols-2 gap-5">
              <button
                className="justify-center px-6 h-10 rounded-[5px] py-2  text-sm border-none cursor-pointer flex gap-2.5 items-center bg-primaryColor text-white"
                onClick={handleExitGame}
              >
                {IconExit} Exit League
              </button>

              <button
                className="justify-center px-6 h-10 rounded-[5px] py-2  text-sm border-none cursor-pointer flex gap-2.5 items-center bg-primaryColor text-white"
                onClick={gameLeaderboard}
              >
                Leadeboard
              </button>
            </div>
          )}
          <div className="md:block  rounded-2xl bg-white max-w-[60rem] mx-auto">
            <div className="flex flex-col md:px-4 px-0  bg-white md:rounded-xl md:shadow-lg md:mx-2 py-2">
              {!game_id && (
                <div className="w-full flex items-center justify-center md:mt-24 mt-[72px]">
                  <FeedTop />
                </div>
              )}
              {isMobileView && (
                <div className="px-2 mt-1 mb-2">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={handleInputChange}
                    className={`border border-grey-400 rounded-full text-sm w-full px-3 py-2 focus:outline-none focus:border-green-300 bg-slate-50 ${
                      isMobileView ? "mt-4" : "md:w-[230px]"
                    }`}
                  />
                  <FontAwesomeIcon
                    className={"-ml-7 mt-6 text-slate-500"}
                    icon={faMagnifyingGlass}
                  ></FontAwesomeIcon>
                </div>
              )}
              {!game_id && posts.length > 0 && (
                <div
                  className={`mt-3 min-h-px bg-gray-300 ${
                    isMobileView && "-mx-2 w-[calc(100%+1rem)]"
                  }`}
                ></div>
              )}
              {posts.filter((post) => post.game_id === game_id).length === 0 &&
                game_id && (
                  <div className="w-full mt-3 text-center">No Posts Yet!!</div>
                )}
              {/* Full width line separator */}
              <div
                className={`bg-white ${
                  isMobileView && "-mx-2 w-[calc(100%+1rem)]"
                }`}
              >
                <main className="h-full bg-#fbfcfc md:pt-2  justify-center">
                  <InfiniteScroll
                    dataLength={posts.length}
                    next={posts.length > 9 && fetchMorePost}
                    hasMore={!postId && hasMore}
                    loader={loader && <SmallLoader />}
                    style={{
                      overflow: "hidden",
                    }}
                    endMessage={
                      !postId && (
                        <p style={{ textAlign: "center" }}>
                          <b>Yay! You have seen it all</b>
                        </p>
                      )
                    }
                  >
                    {/* {!game_id && (
  <> */}
                    {posts.length > 0
                      ? posts
                          .filter((post) => {
                            if (!game_id) {
                              return !post?.game_id; // Include posts without game_id if game_id is not set
                            }
                            return post?.game_id === game_id; // Include posts matching game_id
                          })
                          .map((post, index) => {
                            return isMobileView ? (
                              <>
                                {/* <FeedCard feedData={post} handleLikeDislike={handleLikeDislike} handleShare={handleShare} index={index}/> */}
                                <div
                                  className="w-full bg-white border-b border-[#D7DADF] pb-4"
                                  key={index}
                                  id={
                                    post?.repost?.id
                                      ? post?.repost?.id
                                      : post?.id
                                  }
                                >
                                  <div className="py-3.5 px-[18px] flex items-center justify-between gap-2 ">
                                    <div className="flex items-center gap-2">
                                      {post?.repost?.id &&
                                      loginUserId != post?.repost?.user?.id ? (
                                        <Link
                                          to={`/profile/${post?.repost?.user?.id}`}
                                          className={isMobileView ? "w-10" : ""}
                                        >
                                          <img
                                            src={
                                              post?.repost?.id
                                                ? post?.repost?.user?.image
                                                : post?.user?.image
                                            }
                                            alt="profile"
                                            className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                          />
                                        </Link>
                                      ) : post?.repost?.user?.id ==
                                        loginUserId ? (
                                        <Link
                                          to={`/profile`}
                                          className={isMobileView ? "w-10" : ""}
                                        >
                                          <img
                                            src={
                                              post?.repost?.id
                                                ? post?.repost?.user?.image
                                                : post?.user?.image
                                            }
                                            alt="profile"
                                            className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                          />
                                        </Link>
                                      ) : loginUserId == post?.user?.id ? (
                                        <Link
                                          to={`/profile`}
                                          className={isMobileView ? "w-10" : ""}
                                        >
                                          <img
                                            src={
                                              post?.repost?.id
                                                ? post?.repost?.user?.image
                                                : post?.user?.image
                                            }
                                            alt="profile"
                                            className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                          />
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/profile/${post?.user?.id}`}
                                          className={isMobileView ? "w-10" : ""}
                                        >
                                          <img
                                            src={
                                              post?.repost?.id
                                                ? post?.repost?.user?.image
                                                : post?.user?.image
                                            }
                                            alt="profile"
                                            className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                          />
                                        </Link>
                                      )}

                                      <div>
                                        <span className="text-[15px] font-semibold block leading-tight">
                                          {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                          {post?.user?.green_tick && (
                                            <img
                                              src={GreenTick}
                                              alt="green-tick object-cover"
                                              className="ml-1 "
                                            />
                                          )}
                                        </span>
                                        {post?.repost?.id && (
                                        <span className="text-[11px] font-medium text-[#888888] block">
                                          {post?.user?.user_name} Reposted
                                        </span>
                                        )}
                                      </div>
                                    </div>
                                    <div className="flex items-center justify-between ">
                                      <div>
                                        {/* <span
                                                        className={
                                                          isMobileView
                                                            ? "mr-1 text-base  text-gray-600 font-poppins truncate"
                                                            : "mr-4 text-base  text-gray-600 font-poppins truncate"
                                                        }
                                                      >
                                                        {calculateTimeAgo(
                                                          post?.repost?.id
                                                            ? post?.repost?.created_at
                                                            : post.created_at
                                                        )}
                                                      </span> */}
                                      </div>
                                      {game_id && (
                                        <div>
                                          <span
                                            className={
                                              isMobileView
                                                ? "mr-1 text-base text-gray-600 font-poppins truncate"
                                                : "mr-4 text-base text-gray-600 font-poppins truncate"
                                            }
                                          >
                                            {post.user_id === profile.id && (
                                              <div className="relative inline-block text-left">
                                                <button
                                                  onClick={() =>
                                                    toggleDropdown(index)
                                                  }
                                                  type="button"
                                                  className={
                                                    isMobileView
                                                      ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                      : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                  }
                                                >
                                                  <FontAwesomeIcon
                                                    icon={
                                                      isMobileView
                                                        ? faEllipsisV
                                                        : faEllipsisH
                                                    }
                                                  />
                                                </button>
                                                {dropdownStates[index] && (
                                                  <div className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                    <button
                                                      className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                      onClick={() =>
                                                        handleDeletePost(
                                                          post.id
                                                        )
                                                      }
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faTrash}
                                                        />
                                                        <p className="ml-[0.60rem]">
                                                          Delete
                                                        </p>
                                                      </div>
                                                    </button>
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                        <p className="ml-[0.60rem]">
                                                          Edit
                                                        </p>
                                                      </div>
                                                    </button>
                                                  </div>
                                                )}
                                              </div>
                                            )}
                                          </span>
                                        </div>
                                      )}

                                      {post?.user?.id === profile.id ? (
                                        ""
                                      ) : (
                                        <div
                                          className={
                                            isMobileView
                                              ? "relative inline-block text-left"
                                              : "relative inline-block mr-2 text-left"
                                          }
                                        >
                                          <span
                                            onClick={() =>
                                              toggleDropdown(index)
                                            }
                                            type="button"
                                            className="cursor-pointer"
                                          >
                                            {TheDotsIcon}
                                          </span>
                                          {dropdownStates[index] && (
                                            <div className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                              <button
                                                className="block text-primaryColor w-full  px-2 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                role="menuitem"
                                                onClick={() =>
                                                  handleBlock(
                                                    post?.repost?.id
                                                      ? post?.repost?.user?.id
                                                      : post?.user?.id,
                                                    "block"
                                                  )
                                                }
                                              >
                                                <div className="flex  ml-2">
                                                  <FontAwesomeIcon
                                                    className="h-3 mt-1"
                                                    icon={faBan}
                                                  />{" "}
                                                  <p className="ml-[0.60rem]">
                                                    Block User
                                                  </p>
                                                </div>
                                              </button>
                                              <button
                                                className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                role="menuitem"
                                                onClick={() =>
                                                  handleReport(
                                                    post?.repost?.id
                                                      ? post?.repost?.id
                                                      : post.id,
                                                    "report"
                                                  )
                                                }
                                              >
                                                <div className="flex ml-2">
                                                  <FontAwesomeIcon
                                                    className="h-3 mt-1"
                                                    icon={faFlag}
                                                  />{" "}
                                                  <p className="ml-2">
                                                    Report Post
                                                  </p>
                                                </div>
                                              </button>
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  {post.post_image?.length > 0 ||
                                  post?.repost?.post_image?.length > 0 ? (
                                    post?.repost?.id ? (
                                      post?.repost?.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
{isLoading[post.id] && (
  <div className="absolute inset-0 flex items-center justify-center bg-[#f8f8f8]">
    <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
)}


                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                      className="w-full"
                                                    /> */}
                                                    {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                    {/* </div>
                                                  ) : ( */}
                                                  {/* Mobile video edited 1*/}
                                                    {/* <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      poster={image.thumb}
                                                      autoPlay
                                                      playsInline
                                                      controls="false"
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video> */}
                                                        {/* <video
                                                                  ref={setVideoRef}
                                                                  poster={image.thumb}
                                                                  autoPlay
                                                                  playsInline
                                                                  loop
                                                                  controls={false}
                                                                  className="w-full max-h-full object-contain"
                                                                  onClick={(e) => {
                                                                    handleVideoPlayPause(e.target); // Pause or resume the video
                                                                    handleVideoClick(index, imageIndex); // Handle custom click event
                                                                  }}
                                                                >
                                                                  <source src={image.image} />
                                                                </video> */}


  {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>



                                                  {/* )} */}
                                                </div>
                                              ) : (
                                                <div
                                                  id={`gallery-${post.id}`}
                                                  style={galleryStyles}
                                                >
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      post.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
{isLoading[post.id] && (
  <div className="absolute inset-0 flex items-center justify-center bg-[#f8f8f8]">
    <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
)}

                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      className={"w-full"}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                    /> */}
                                                    {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                    {/* </div>
                                                  ) : ( */}
                                                  {/* mobile view edited 2 */}
                                                    {/* <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      poster={image.thumb}
                                                      autoPlay
                                                      playsInline
                                                      controls="false"
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video> */}

                                                      {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>

                                                  {/* )} */}
                                                </div>
                                              ) : (
                                                <div
                                                  id={`gallery-${post.id}`}
                                                  style={galleryStyles}
                                                >
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    )
                                  ) : (
                                    <div className="py-3.5 px-[18px]  bg-white">
                                      <p className="text-base  font-medium whitespace-pre-line text-black">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                      <>
                                                  ...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="ml-2 text-[#888888]"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                      <>
                                                    ... <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] "
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                  </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  )}
                                  <div className="p-4 space-y-2">
                                    <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-4">
                                        <button
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id
                                            ? post?.repost?.is_like_by_me
                                              ? HeartFilledIcon
                                              : HeartIcon
                                            : post?.is_like_by_me
                                            ? HeartFilledIcon
                                            : HeartIcon}

                                      <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>

                                        </button>

                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {CommentIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>

                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                        >
                                          {ShareIcon}
                                        </button>
                                        {/* <button>{RepostIcon}</button> */}

                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post.user_id
                                                : "",
                                              post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          {RepostIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>
                                      </div>
                                      {/* <button>{SaveIcon}</button> */}

                                      <button
                                        disabled={isDisabled ? true : false}
                                        onClick={() =>
                                          handleSavePost(
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          )
                                        }
                                      >
                                        {post?.repost?.id ? (
                                              post?.repost?.is_saved
                                                ? <>{SaveIconFill}</>
                                                :  <>{SaveIcon}</>
                                        ) : (
                                              post.is_saved ? <>{SaveIconFill}</>
                                                :<> {SaveIcon}</>
                                        )}
                                      </button>
                                    </div>
                                    <p>
                                      <span className="text-sm font-semibold">
                                        {/* {post?.repost?.id
                                          ? post?.repost?.total_likes
                                          : post.total_likes}{" "}
                                        likes */}
                                        {post?.user?.user_name}
                                      </span>{" "}
                                      <span className="text-[#888888] px-2">
                                        ·
                                      </span>
                                      <span className="text-[#888888] text-[12px] font-semibold">
                                        {calculateTimeAgo(
                                          post?.repost?.id
                                            ? post?.repost?.created_at
                                            : post.created_at
                                        )}
                                      </span>
                                    </p>
                                    {post.post_image?.length > 0 && (
                                      <p className="text-base font-medium whitespace-pre-line">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                    <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="ml-2"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                      <>
                                                    ... <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] "
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                  </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                    )}
                                    {commentOpenStates[index] && (
                                      <div className="mt-4 text-black  md:ml-[60px] lg:ml-[60px]">
                                        <div className="mt-4 space-y-2">
                                          {!loadingComment &&
                                          postComments[
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          ] &&
                                          postComments[
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          ].length > 0 ? (
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].map((comment) => (
                                              <div
                                                key={comment.id}
                                                className="flex items-start mb-2"
                                              >
                                                <div className="flex-shrink-0">
                                                  <img
                                                    src={comment?.user?.image}
                                                    alt={`${comment?.user?.user_name}'s avatar`}
                                                    className="w-8 h-8 rounded-full mr-2"
                                                  />
                                                </div>
                                                <div className="w-full">
                                                  <div className="flex justify-between mb-1">
                                                    <span className="font-semibold ml-2">
                                                      {comment?.user?.user_name}
                                                    </span>
                                                    {comment?.user.id ===
                                                      profile?.id && (
                                                      <button
                                                        disabled={
                                                          isDisabled
                                                            ? true
                                                            : false
                                                        }
                                                        className="px-5 text-green-500 "
                                                        onClick={() =>
                                                          handleDeleteComment(
                                                            comment.id
                                                          )
                                                        }
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={faTrash}
                                                        />
                                                      </button>
                                                    )}
                                                  </div>
                                                  <div className="flex justify-between">
                                                    <div
                                                      className={
                                                        "md:w-full w-52 ml-2"
                                                      }
                                                    >
                                                      <p className="w-full break-words text-sm"   style={{
                                                          whiteSpace: 'pre-wrap', // Ensures that spaces and newlines are preserved
                                                          wordBreak: 'break-word', // Breaks long words if necessary to prevent overflow
                                                        }}>
                                                        {comment?.comment}
                                                      </p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            ))
                                          ) : loadingComment ? (
                                            <SmallLoader />
                                          ) : (
                                            !loadingComment && (
                                              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                <p>No comments yet</p>
                                              </div>
                                            )
                                          )}
                                        </div>
                                        <div
                                          className={`mt-4 relative ${
                                            postId ? "mb-[60px]" : ""
                                          }`}
                                        >
                                          <div className="flex">
                                            {/* <input
                                              type="text"
                                              value={newComment}
                                              onChange={(e) =>
                                                setNewComment(e.target.value)
                                              }
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1 }} // Ensures the input takes up remaining space
                                            /> */}
                                            <textarea
                                              value={newComment}
                                              onChange={(e) => setNewComment(e.target.value)}
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1, resize: 'vertical' }} // Allows resizing vertically
                                              rows={3} // You can adjust this number
                                            />

                                            <button
                                              className="ml-2 bg-primaryColor mt-2 text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                              disabled={
                                                isDisabled ? true : false
                                              }
                                              onClick={() =>
                                                handleAddComment(
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                  index
                                                )
                                              }
                                              style={{
                                                height: 30,
                                                minWidth: 84, // Set a minimum width for the button
                                              }}
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  {isModalOpen && (
                                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">

                                      <div className="bg-white p-6 rounded shadow-lg">
                                        {/* Modal content goes here */}
                                        <p>
                                          Are you sure, You want to delete this
                                          post?
                                        </p>
                                        <button
                                          onClick={handleDelete}
                                          className="bg-red-500 text-white py-2 px-4 rounded mt-4 mr-2"
                                        >
                                          Delete Post
                                        </button>
                                        <button
                                          onClick={handleCloseModal}
                                          className="bg-gray-500 text-white py-2 px-4 rounded mt-4"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  )}
                              {(post?.repost?.id ? post?.repost?.total_comments : post.total_comments) >= 1 && (
                                <p
                                  onClick={() =>
                                    handleCommentToggle(
                                      index,
                                      post?.repost?.id ? post?.repost?.id : post.id
                                    )
                                  }
                                  className="cursor-pointer text-[#888888]"
                                >
                                  View all{" "}
                                  <span>
                                    {post?.repost?.id ? post?.repost?.total_comments : post.total_comments}
                                  </span>{" "}
                                  comments
                                </p>
                              )}
                                  </div>
                                </div>
                              </>
                            ) : (
                              <div
                                key={index}
                                className="text-white pb-2 flex flex-col"
                                id={
                                  post?.repost?.id ? post?.repost?.id : post?.id
                                }
                              >
                                {post?.repost?.id && (
                                  <div className="text-black">
                                    <div className="flex items-center mb-2 ml-0 md:ml-12">
                                      <FontAwesomeIcon
                                        className="text-primaryColor mr-2"
                                        icon={faRepeat}
                                      />
                                      <p
                                        className="text-lg font-bold whitespace-nowrap"
                                        style={{ color: "#004c50" }}
                                      >
                                        {post?.user?.user_name} Reposted
                                      </p>
                                    </div>
                                  </div>
                                )}
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center">
                                    {post?.repost?.id &&
                                    loginUserId != post?.repost?.user?.id ? (
                                      <Link
                                        to={`/profile/${post?.repost?.user?.id}`}
                                        className={isMobileView ? "w-10" : ""}
                                      >
                                        <img
                                          src={
                                            post?.repost?.id
                                              ? post?.repost?.user?.image
                                              : post?.user?.image
                                          }
                                          alt="profile"
                                          className={`rounded-full ${
                                            isMobileView
                                              ? "h-10 w-full mr-0 object-cover"
                                              : "h-10 w-10  mr-2  object-cover"
                                          }`}
                                        />
                                      </Link>
                                    ) : post?.repost?.user?.id ==
                                      loginUserId ? (
                                      <Link
                                        to={`/profile`}
                                        className={isMobileView ? "w-10" : ""}
                                      >
                                        <img
                                          src={
                                            post?.repost?.id
                                              ? post?.repost?.user?.image
                                              : post?.user?.image
                                          }
                                          alt="profile"
                                          className={`rounded-full ${
                                            isMobileView
                                              ? "h-10 w-full mr-0 object-cover"
                                              : "h-10 w-10  mr-2  object-cover"
                                          }`}
                                        />
                                      </Link>
                                    ) : loginUserId == post?.user?.id ? (
                                      <Link
                                        to={`/profile`}
                                        className={isMobileView ? "w-10" : ""}
                                      >
                                        <img
                                          src={
                                            post?.repost?.id
                                              ? post?.repost?.user?.image
                                              : post?.user?.image
                                          }
                                          alt="profile"
                                          className={`rounded-full ${
                                            isMobileView
                                              ? "h-10 w-full mr-0 object-cover"
                                              : "h-10 w-10  mr-2  object-cover"
                                          }`}
                                        />
                                      </Link>
                                    ) : (
                                      <Link
                                        to={`/profile/${post?.user?.id}`}
                                        className={isMobileView ? "w-10" : ""}
                                      >
                                        <img
                                          src={
                                            post?.repost?.id
                                              ? post?.repost?.user?.image
                                              : post?.user?.image
                                          }
                                          alt="profile"
                                          className={`rounded-full ${
                                            isMobileView
                                              ? "h-10 w-full mr-0 object-cover"
                                              : "h-10 w-10  mr-2  object-cover"
                                          }`}
                                        />
                                      </Link>
                                    )}

                                    {/* <div>
                                  {post?.repost?.id &&
                                  loginUserId != post?.repost?.user?.id ? (
                                    <Link
                                      to={`/profile/${post?.repost?.user?.id}`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                      </span>
                                    </Link>
                                  ) : post?.repost?.user?.id == loginUserId ? (
                                    <Link
                                      to={`/profile`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                      </span>
                                    </Link>
                                  ) : loginUserId == post?.user?.id ? (
                                    <Link
                                      to={`/profile`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                      </span>
                                    </Link>
                                  ) : (
                                    <Link
                                      to={`/profile/${post?.user?.id}`}
                                      className={isMobileView ? "w-10" : ""}
                                    >
                                      <span
                                        className={
                                          isMobileView
                                            ? "text-[14px] ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                            : "px-1 ml-2 sm:ml-[16] text-auto text-black font-bold font-poppins whitespace-nowrap"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.user?.user_name
                                          : post?.user?.user_name}
                                      </span>
                                    </Link>
                                  )}
                                </div> */}

                                    <span
                                      className={
                                        isMobileView
                                          ? "px-1 text-[19px] sm:ml-[0] text-auto text-black font-bold font-poppins truncate"
                                          : "px-1 sm:ml-[0]  text-[20px] text-black font-bold font-poppins truncate"
                                      }
                                    >
                                      {/* @QUSHI */}@
                                      {post?.repost?.id
                                        ? post?.repost?.user?.user_name
                                        : post?.user?.user_name}
                                    </span>

                                    {post?.user?.green_tick ? (
                                      <img
                                        src={GreenTick}
                                        alt="green-tick object-cover"
                                        className="ml-1 "
                                      />
                                    ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                    null}
                                  </div>
                                  <div className="flex items-center justify-between ">
                                    <div>
                                      <span
                                        className={
                                          isMobileView
                                            ? "mr-1 text-base  text-gray-600 font-poppins truncate"
                                            : "mr-4 text-base  text-gray-600 font-poppins truncate"
                                        }
                                      >
                                        {calculateTimeAgo(
                                          post?.repost?.id
                                            ? post?.repost?.created_at
                                            : post.created_at
                                        )}
                                      </span>
                                    </div>
                                    {game_id && (
                                      <div>
                                        <span
                                          className={
                                            isMobileView
                                              ? "mr-1 text-base text-gray-600 font-poppins truncate"
                                              : "mr-4 text-base text-gray-600 font-poppins truncate"
                                          }
                                        >
                                          {post.user_id === profile.id && (
                                            <div className="relative inline-block text-left">
                                              <button
                                                onClick={() =>
                                                  toggleDropdown(index)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                    : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                                }
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                />
                                              </button>
                                              {dropdownStates[index] && (
                                                <div className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                                  <button
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                      <p className="ml-[0.60rem]">
                                                        Delete
                                                      </p>
                                                    </div>
                                                  </button>
                                                  <button
                                                    onClick={() =>
                                                      handleEditClick(
                                                        post?.repost?.id
                                                          ? post?.repost?.id
                                                          : post.id
                                                      )
                                                    }
                                                    className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faEdit}
                                                      />
                                                      <p className="ml-[0.60rem]">
                                                        Edit
                                                      </p>
                                                    </div>
                                                  </button>
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </span>
                                      </div>
                                    )}

                                    {post?.user?.id === profile.id ? (
                                      ""
                                    ) : (
                                      <div
                                        className={
                                          isMobileView
                                            ? "relative inline-block text-left"
                                            : "relative inline-block mr-2 text-left"
                                        }
                                      >
                                        <button
                                          onClick={() => toggleDropdown(index)}
                                          type="button"
                                          className={
                                            isMobileView
                                              ? "z-50  w-full bg-white-400 text-[12px]  text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                              : "z-50  w-full bg-white-400 text-green-700 px-2 py-2 hover:bg-primaryColor hover:text-white rounded flex items-center"
                                          }
                                        >
                                          <FontAwesomeIcon
                                            icon={
                                              isMobileView
                                                ? faEllipsisV
                                                : faEllipsisH
                                            }
                                          />
                                        </button>
                                        {dropdownStates[index] && (
                                          <div className="z-50 origin-top-right text-green-500 absolute right-1 mt-0 w-32 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 mr-[-10px]">
                                            <button
                                              className="block text-primaryColor w-full  px-2 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                              role="menuitem"
                                              onClick={() =>
                                                handleBlock(
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.id
                                                    : post?.user?.id,
                                                  "block"
                                                )
                                              }
                                            >
                                              <div className="flex  ml-2">
                                                <FontAwesomeIcon
                                                  className="h-3 mt-1"
                                                  icon={faBan}
                                                />{" "}
                                                <p className="ml-[0.60rem]">
                                                  Block User
                                                </p>
                                              </div>
                                            </button>
                                            <button
                                              className="block w-full text-primaryColor px-2.5 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                              role="menuitem"
                                              onClick={() =>
                                                handleReport(
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                  "report"
                                                )
                                              }
                                            >
                                              <div className="flex ml-2">
                                                <FontAwesomeIcon
                                                  className="h-3 mt-1"
                                                  icon={faFlag}
                                                />{" "}
                                                <p className="ml-2">
                                                  Report Post
                                                </p>
                                              </div>
                                            </button>
                                          </div>
                                        )}
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div
                                  className={
                                    isMobileView
                                      ? "ml-12  px-0 my-2 sm:px-10 font-poppins pswp-gallery"
                                      : "ml-6  px-0 my-2 sm:px-10 font-poppins pswp-gallery"
                                  }
                                >
                                  {post?.repost?.id ? (
                                    <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                      {(() => {
                                        const getTrimmedDescription = (
                                          description,
                                          limit
                                        ) => {
                                          if (!description) return "";
                                          if (description.length <= limit)
                                            return description;

                                          const trimmed = description.substring(
                                            0,
                                            limit
                                          );
                                          return (
                                            trimmed.substring(
                                              0,
                                              trimmed.lastIndexOf(" ")
                                            ) + " "
                                          );
                                        };

                                        const description = showFullDescription[
                                          index
                                        ]
                                          ? post?.description
                                          : getTrimmedDescription(
                                              post?.description,
                                              255
                                            );

                                        if (!description) {
                                          return null;
                                        }

                                        return (
                                          <>
                                            {description}
                                            {post?.description?.length >
                                              255 && (
                                              <button
                                                onClick={() => {
                                                  setShowFullDescription(
                                                    (prevState) => {
                                                      const newState = [
                                                        ...prevState,
                                                      ];
                                                      newState[index] =
                                                        !newState[index];
                                                      return newState;
                                                    }
                                                  );
                                                }}
                                                className="text-green-500 ml-2"
                                              >
                                                {showFullDescription[index]
                                                  ? "Show less"
                                                  : "Show more"}
                                              </button>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                  ) : (
                                    <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                      {(() => {
                                        const getTrimmedDescription = (
                                          description,
                                          limit
                                        ) => {
                                          if (!description) return "";
                                          if (description.length <= limit)
                                            return description;

                                          const trimmed = description.substring(
                                            0,
                                            limit
                                          );
                                          return (
                                            trimmed.substring(
                                              0,
                                              trimmed.lastIndexOf(" ")
                                            ) + " "
                                          );
                                        };

                                        const description = showFullDescription[
                                          index
                                        ]
                                          ? post?.description
                                          : getTrimmedDescription(
                                              post?.description,
                                              255
                                            );

                                        if (!description) {
                                          return null;
                                        }

                                        return (
                                          <>
                                            {description}
                                            {post?.description?.length >
                                              255 && (
                                              <button
                                                onClick={() => {
                                                  setShowFullDescription(
                                                    (prevState) => {
                                                      const newState = [
                                                        ...prevState,
                                                      ];
                                                      newState[index] =
                                                        !newState[index];
                                                      return newState;
                                                    }
                                                  );
                                                }}
                                                className="text-green-500 ml-2"
                                              >
                                                {showFullDescription[index]
                                                  ? "Show less"
                                                  : "Show more"}
                                              </button>
                                            )}
                                          </>
                                        );
                                      })()}
                                    </div>
                                  )}
                                </div>
                                <div
                                  className={
                                    isMobileView
                                      ? "ml-12  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                      : "ml-6  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                  }
                                >
                                  {post?.repost?.id
                                    ? post?.repost?.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];
                                          return (
                                            <div
                                              key={imageIndex}
                                              className="mr-2 mb-2"
                                            >
                                              {console.log(
                                                "Feed URL:",
                                                image.image.split("?")[0]
                                              )}
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div
                                                  className={`relative ${
                                                    post?.repost?.post_image.length == 1
                                                      ? isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                      : isMobileView
                                                      ? "w-[300px] h-[350px] rounded-lg"
                                                      : "w-[780px] h-[400px] rounded-lg"
                                                  }`}
                                                >
                                                  {/* {shouldShowThumbnail ? (
                                                    <div>
                                                      <img
                                                        src={image.thumb}
                                                        id={`image-${key}`}
                                                        className={
                                                          post?.repost
                                                            ?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                              : "w-[780px] h-[400px] object-contain rounded-lg "
                                                            : isMobileView
                                                            ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                            : "w-[780px] h-[400px]  object-contain rounded-lg "
                                                        }
                                                        alt="Video Thumbnail"
                                                        onClick={(e) => {
                                                          handleVideoClick(
                                                            index,
                                                            imageIndex
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  )
                                                  : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autobuffer
                                                      controls
                                                      playsInline={true}
                                                      webkit-playsinline="true"
                                                      x5-playsinline="true"
                                                      x-webkit-airplay="deny"
                                                      disablePictureInPicture={
                                                        true
                                                      }
                                                      controlsList="nodownload"
                                                      onContextMenu={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      loop
                                                      autoPlay
                                                      id={`video-${key}`}
                                                      preload="auto"
                                                      className="w-full h-full object-contain rounded-lg"
                                                      onLoadedMetadata={(e) => {
                                                        if (isMobileView) {
                                                          e.target.currentTime = 1;
                                                        }
                                                      }}
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )} */}

                                                  {/* <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                  <div className="w-[780px] h-[400px] relative rounded-lg" onClick={() => togglePlay(post.id)}>

                                                    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center z-10">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-5xl opacity-60"
      />
    </div>
  )}

                                                                              <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>

    </div>
                                                </div>
                                              ) : (
                                                <div
                                                  id={`gallery-${post.id}`}
                                                  style={galleryStyles}
                                                >
                                                  <a
                                                    href={image.image}
                                                    key={`image-${imageIndex}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={linkStyles}
                                                  >
                                                    <img
                                                      src={image.image}
                                                      alt={`Post Image ${
                                                        imageIndex + 1
                                                      }`}
                                                      style={imageStyles}
                                                      onLoad={(event) =>
                                                        handleImageLoaded(
                                                          event,
                                                          index
                                                        )
                                                      }
                                                    />
                                                  </a>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    : post.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="mr-2 mb-2"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div
                                                    className={`relative ${
                                                      post?.repost?.post_image.length == 1
                                                        ? isMobileView
                                                          ? "w-[300px] h-[350px] rounded-lg"
                                                          : "w-[780px] h-[400px] rounded-lg"
                                                        : isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                    }`}
                                                >
                                                  {/* {shouldShowThumbnail ? (
                                                    <div>
                                                      <img
                                                        src={image.thumb}
                                                        id={`image-${key}`}
                                                        className={
                                                          post?.post_image
                                                            .length == 1
                                                            ? isMobileView
                                                              ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                              : "w-[780px] h-[400px] object-contain rounded-lg "
                                                            : isMobileView
                                                            ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                            : "w-[780px] h-[400px]  object-contain rounded-lg "
                                                        }
                                                        alt="Video Thumbnail"
                                                        onClick={(e) => {
                                                          handleVideoClick(
                                                            index,
                                                            imageIndex
                                                          );
                                                        }}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      controls
                                                      autoPlay
                                                      autobuffer
                                                      playsInline={true}
                                                      webkit-playsinline="true"
                                                      x5-playsinline="true"
                                                      x-webkit-airplay="deny"
                                                      disablePictureInPicture={
                                                        true
                                                      }
                                                      onContextMenu={(e) =>
                                                        e.preventDefault()
                                                      }
                                                      preload="auto"
                                                      id={`video-${key}`}
                                                      className="w-full h-full object-contain rounded-lg"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )}

                                                  <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() =>
                                                      handleVideoClick(
                                                        index,
                                                        imageIndex
                                                      )
                                                    }
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button> */}
                                                  <div className="w-[780px] h-[400px] object-contain rounded-lg" onClick={() => togglePlay(post.id)}>
                                                    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

                                                                              <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>

    </div>
                                                </div>
                                              ) : (
                                                <div
                                                  id={`gallery-${post.id}`}
                                                  style={galleryStyles}
                                                >
                                                  {" "}
                                                  <a
                                                    href={image.image}
                                                    key={`image-${imageIndex}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={linkStyles}
                                                  >
                                                    <img
                                                      src={image.image}
                                                      alt={`Post Image ${
                                                        imageIndex + 1
                                                      }`}
                                                      style={imageStyles}
                                                      onLoad={(event) =>
                                                        handleImageLoaded(
                                                          event,
                                                          index
                                                        )
                                                      }
                                                    />
                                                  </a>
                                                </div>
                                              )}
                                            </div>
                                          );
                                        }
                                      )}
                                </div>
                                <div className="flex flex-row md:ml-8 ml-[2.8rem] justify-between items-center px-4 sm:px-8 my-4 text-green-500 space-x-4">
                                  <button
                                    onClick={() =>
                                      handleCommentToggle(
                                        index,
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id
                                      )
                                    }
                                    className="flex flex-row justify-center items-center"
                                  >
                                    <FontAwesomeIcon icon={empty2} />
                                    <p className="ml-1 md:text-xs text-base">
                                      {post?.repost?.id
                                        ? post?.repost?.total_comments
                                        : post.total_comments}
                                    </p>
                                  </button>
                                  <button
                                    disabled={isDisabled ? true : false}
                                    onClick={() =>
                                      handleRepost(
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id,
                                        post?.repost?.id ? post.user_id : "",
                                        post.id
                                      )
                                    }
                                    className="flex flex-row justify-center items-center "
                                  >
                                    <FontAwesomeIcon icon={faRepeat} />
                                    <p className="ml-1 md:text-xs text-base">
                                      {post?.repost?.id
                                        ? post?.repost?.repost_count
                                        : post.repost_count}
                                    </p>
                                  </button>
                                  <button
                                    disabled={isDisabled ? true : false}
                                    onClick={() =>
                                      handleLikeDislike(
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id,
                                        post.total_likes
                                      )
                                    }
                                    className="flex flex-row justify-center items-center"
                                  >
                                    {post?.repost?.id ? (
                                      <FontAwesomeIcon
                                        icon={
                                          post?.repost?.is_like_by_me
                                            ? faHeart
                                            : empty
                                        }
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={
                                          post?.is_like_by_me ? faHeart : empty
                                        }
                                      />
                                    )}

                                    <p className="ml-1 md:text-xs text-base">
                                      {post?.repost?.id
                                        ? post?.repost?.total_likes
                                        : post.total_likes}
                                    </p>
                                  </button>

                                  <button
                                    disabled={isDisabled ? true : false}
                                    onClick={() =>
                                      handleSavePost(
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id
                                      )
                                    }
                                    className="flex flex-row justify-center items-center "
                                  >
                                    {post?.repost?.id ? (
                                      <FontAwesomeIcon
                                        icon={
                                          post?.repost?.is_saved
                                            ? saved
                                            : faBookmark
                                        }
                                      />
                                    ) : (
                                      <FontAwesomeIcon
                                        icon={
                                          post.is_saved ? saved : faBookmark
                                        }
                                      />
                                    )}
                                  </button>
                                  {isModalOpen && (
                                    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center">

                                      <div className="bg-white p-6 rounded shadow-lg">
                                        {/* Modal content goes here */}
                                        <p>
                                          Are you sure, You want to delete this
                                          post?
                                        </p>
                                        <button
                                          onClick={handleDelete}
                                          className="bg-red-500 text-white py-2 px-4 rounded mt-4 mr-2"
                                        >
                                          Delete Post
                                        </button>
                                        <button
                                          onClick={handleCloseModal}
                                          className="bg-gray-500 text-white py-2 px-4 rounded mt-4"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  <button
                                    onClick={() =>
                                      handleShare(
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id
                                      )
                                    }
                                    className="flex flex-row justify-center items-center"
                                  >
                                    <FontAwesomeIcon
                                      icon={faArrowUpFromBracket}
                                    />
                                  </button>
                                </div>
                                {commentOpenStates[index] && (
                                  <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                    <div className="mt-4 space-y-2">
                                      {!loadingComment &&
                                      postComments[
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id
                                      ] &&
                                      postComments[
                                        post?.repost?.id
                                          ? post?.repost?.id
                                          : post.id
                                      ].length > 0 ? (
                                        postComments[
                                          post?.repost?.id
                                            ? post?.repost?.id
                                            : post.id
                                        ].map((comment) => (
                                          <div
                                            key={comment.id}
                                            className="flex items-start mb-2"
                                          >
                                            <div className="flex-shrink-0">
                                              <img
                                                src={comment?.user?.image}
                                                alt={`${comment?.user?.user_name}'s avatar`}
                                                className="w-8 h-8 rounded-full mr-2"
                                              />
                                            </div>
                                            <div className="w-full">
                                              <div className="flex justify-between mb-1">
                                                <span className="font-semibold ml-2">
                                                  {comment?.user?.user_name}
                                                </span>
                                                {comment?.user.id ===
                                                  profile?.id && (
                                                  <button
                                                    disabled={
                                                      isDisabled ? true : false
                                                    }
                                                    className="px-5 text-green-500 "
                                                    onClick={() =>
                                                      handleDeleteComment(
                                                        comment.id
                                                      )
                                                    }
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faTrash}
                                                    />
                                                  </button>
                                                )}
                                              </div>
                                              <div className="flex justify-between">
                                                <div
                                                  className={"md:w-full w-52 ml-2"}
                                                >
                                                  <p className="w-full break-words text-sm"   style={{
                                                        whiteSpace: 'pre-wrap', // Ensures that spaces and newlines are preserved
                                                        wordBreak: 'break-word', // Breaks long words if necessary to prevent overflow
                                                      }}>
                                                    {comment?.comment}
                                                  </p>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : loadingComment ? (
                                        <SmallLoader />
                                      ) : (
                                        !loadingComment && (
                                          <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                            <p>No comments yet</p>
                                          </div>
                                        )
                                      )}
                                    </div>
                                    <div
                                      className={`mt-4 relative ${
                                        postId ? "mb-[60px]" : ""
                                      }`}
                                    >
                                      <div className="flex">
                                        {/* <input
                                          type="text"
                                          value={newComment}
                                          onChange={(e) =>
                                            setNewComment(e.target.value)
                                          }
                                          placeholder="Add a comment..."
                                          className="p-2 border border-emerald-500 rounded w-full text-black"
                                          style={{ flex: 1 }} // Ensures the input takes up remaining space
                                        /> */}
                                        <textarea
  value={newComment}
  onChange={(e) => setNewComment(e.target.value)}
  placeholder="Add a comment..."
  className="p-2 border border-emerald-500 rounded w-full text-black"
  style={{ flex: 1, resize: 'vertical' }} // Allows resizing vertically
  rows={3} // You can adjust this number
/>

                                        <button
                                          className="ml-2 bg-primaryColor mt-2 text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleAddComment(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              index
                                            )
                                          }
                                          style={{
                                            height: 30,
                                            minWidth: 84, // Set a minimum width for the button
                                          }}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="w-full mt-3 h-px bg-gray-300">
                                  No post found
                                </div>{" "}
                                {/* Full width line separator */}
                              </div>
                            );
                          })
                      : posts.length === 0 &&
                        postId &&
                        !loader && (
                          <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                            <p>No posts available.</p>
                          </div>
                        )}
                    {/* {posts.length === 0 && (
                          <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                            <p>No posts available.</p>
                          </div>
                        )} */}
                    {/* </>
)} */}
                  </InfiniteScroll>
                  {/* </div> */}
                </main>
              </div>
            </div>
          </div>
        </div>
      </PageContainer>
      <UndoRepostModal
        isOpen={postUndo}
        handleUndoRepost={handleUndoRepost}
        handleUndoCancel={handleUndoCancel}
      >
        <div className={"mb-4"}>
          <p>{"Are you sure you want to undo this reposted post?"}</p>
        </div>
      </UndoRepostModal>
      <BlockReportModal
        isOpen={isBlockOpen}
        type={postType}
        handleBlockUser={handleBlockUser}
        handleReportPost={handleReportPost}
        handleBlockUserCancel={handleBlockUserCancel}
      >
        <div className={postType === "block" ? "mb-4" : ""}>
          <p>
            {postType === "block"
              ? "Are you sure you want to block this user?"
              : "Are you sure you want to report this post?"}
          </p>
        </div>
        {postType === "block" ? (
          ""
        ) : (
          <div className="mt-4 mb-4">
            <textarea
              value={reportComment}
              className="w-full px-4 py-3 rounded-lg border-2 border-gray-200"
              placeholder="Please enter comment here"
              onChange={(e) => setReportComment(e.target.value)}
            />
          </div>
        )}
      </BlockReportModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </>
  );
};

export default FeedPage;
